
const namespaced = true;

const state = {
  originPath: `/`,
  slug: ``,
  username: ``,
  password: ``,
  repeatPassword: ``,
  isLoginWithEmail: true,
  isPasswordInit: false,
  initPasswordToken: null,
  isInitPasswordTokenValid: false,
};

const mutations = {
  SET_ORIGIN_PATH(state, originPath) {
    state.originPath = originPath || `/`;
  },
  SET_IS_LOGIN_WITH_EMAIL(state, isLoginWithEmail) {
    state.isLoginWithEmail = isLoginWithEmail;
  },
  SET_SLUG(state, slug) {
    state.slug = slug;
  },
  SET_USERNAME(state, username) {
    state.username = username;
  },
  SET_PASSWORD(state, password) {
    state.password = password;
  },
  SET_REPEAT_PASSWORD(state, repeatPassword) {
    state.repeatPassword = repeatPassword;
  },
  SET_IS_PASSWORD_INIT(state, isPasswordInit) {
    state.isPasswordInit = isPasswordInit;
  },
  SET_INIT_PASSWORD_TOKEN(state, initPasswordToken) {
    state.initPasswordToken = initPasswordToken;
  },
  SET_IS_INIT_PASSWORD_TOKEN_VALID(state, isInitPasswordTokenValid) {
    state.isInitPasswordTokenValid = isInitPasswordTokenValid;
  },
};

const actions = {
  saveOriginPath({ commit }, originPath) {
    commit(`SET_ORIGIN_PATH`, originPath);
  },
  async login({ state, dispatch }) {
    const res = await dispatch(`model/auth/login`, {
      slug: state.slug.length ? state.slug : null,
      username: state.username,
      password: state.password,
    }, { root: true });

    if (res?.ssoToken) {
      return res;
    }

    return dispatch(`model/user/fetchMe`, null, { root: true });
  },
  async initPassword({ state, commit, dispatch }) {
    const isPasswordInit = await dispatch(`model/auth/initPassword`, {
      username: state.username,
    }, { root: true });

    commit(`SET_IS_PASSWORD_INIT`, isPasswordInit);
  },
  async testInitPasswordToken({ state, commit, dispatch }) {
    const isInitPasswordTokenValid = await dispatch(`model/auth/testInitPasswordToken`, {
      token: state.initPasswordToken,
    }, { root: true });

    commit(`SET_IS_INIT_PASSWORD_TOKEN_VALID`, isInitPasswordTokenValid);
  },
  async setPassword({ state, commit, dispatch }) {
    const user = await dispatch(`model/auth/setPassword`, {
      token: state.initPasswordToken,
      password: state.password,
    }, { root: true });

    if (user) {
      commit(`SET_USERNAME`, user.email || user.username);
    }
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
